'use client';
import React from 'react';
import * as ContextMenuPrimitive from '@radix-ui/react-context-menu';
import { styled } from '../stitches.config.js';
import { ChevronRightIcon } from '@radix-ui/react-icons';

function handleType(unit) {
    if (Array.isArray(unit))
        return React.createElement(React.Fragment, null, unit.map(x => handleType(x)));
    if (unit === 'separator')
        return React.createElement(ContextMenuSeparator, null);
    if ('content' in unit && Array.isArray(unit.content)) { // submenu
        return (React.createElement(ContextMenuSub, { key: unit.label },
            React.createElement(ContextMenuSubTrigger, null,
                unit.label,
                React.createElement(RightSlot, null, unit.rightSlot || React.createElement(ChevronRightIcon, null))),
            React.createElement(ContextMenuSubContent, { sideOffset: 2, alignOffset: -5 }, handleType(unit.content))));
    }
    // item
    return (React.createElement(ContextMenuItem, { key: unit.label, onSelect: unit.onSelect },
        unit.label,
        " ",
        React.createElement(RightSlot, null, unit.rightSlot)));
}
const ContextMenu = ({ units = [], children: child, title, }) => {
    return (React.createElement(ContextMenuRoot, null,
        React.createElement(ContextMenuTrigger, { asChild: true }, child),
        React.createElement(ContextMenuContent, { sideOffset: 5, align: "end" },
            title && React.createElement(React.Fragment, null,
                React.createElement(ContextMenuLabel, null, title),
                React.createElement(ContextMenuSeparator, null)),
            React.createElement(ContextMenuItem, { onSelect: () => history.back() },
                "Back ",
                React.createElement(RightSlot, null, "\u2318+[")),
            React.createElement(ContextMenuItem, { onSelect: () => history.forward() },
                "Foward ",
                React.createElement(RightSlot, null, "\u2318+]")),
            React.createElement(ContextMenuItem, { onSelect: () => { window.location.reload(); } },
                "Reload ",
                React.createElement(RightSlot, null, "\u2318+R")),
            handleType(units))));
};
const contentStyles = {
    minWidth: 220,
    backgroundColor: '$loContrast',
    borderRadius: 6,
    overflow: 'hidden',
    padding: 5,
    zIndex: 500,
    boxShadow: '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
    // boxShadow: '$colors$shadowLight 0px 10px 38px -10px, $colors$shadowDark 0px 10px 20px -15px'
};
const StyledContent = styled(ContextMenuPrimitive.Content, Object.assign({}, contentStyles));
function Content(props) {
    return (React.createElement(ContextMenuPrimitive.Portal, null,
        React.createElement(StyledContent, Object.assign({}, props))));
}
const StyledSubContent = styled(ContextMenuPrimitive.SubContent, Object.assign(Object.assign({}, contentStyles), { minWidth: contentStyles.minWidth / 2, width: 'max-content' }));
function SubContent(props) {
    return (React.createElement(ContextMenuPrimitive.Portal, null,
        React.createElement(StyledSubContent, Object.assign({}, props))));
}
const itemStyles = {
    all: 'unset',
    fontSize: 13,
    lineHeight: 1,
    color: '$primary11',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    height: 25,
    padding: '0 5px',
    position: 'relative',
    paddingLeft: 25,
    userSelect: 'none',
    '&[data-disabled]': {
        color: '$gray8',
        pointerEvents: 'none',
    },
    '&[data-highlighted]': {
        backgroundColor: '$primary9',
        color: '$primary1',
    },
};
const StyledItem = styled(ContextMenuPrimitive.Item, Object.assign({}, itemStyles));
styled(ContextMenuPrimitive.CheckboxItem, Object.assign({}, itemStyles));
styled(ContextMenuPrimitive.RadioItem, Object.assign({}, itemStyles));
const StyledSubTrigger = styled(ContextMenuPrimitive.SubTrigger, Object.assign({ '&[data-state="open"]': {
        backgroundColor: '$primary4',
        color: '$primary11',
    } }, itemStyles));
const StyledLabel = styled(ContextMenuPrimitive.Label, {
    paddingLeft: 25,
    fontSize: 12,
    lineHeight: '25px',
    color: '$gray11',
});
const StyledSeparator = styled(ContextMenuPrimitive.Separator, {
    height: 1,
    backgroundColor: '$primary6',
    margin: 5,
});
styled(ContextMenuPrimitive.ItemIndicator, {
    position: 'absolute',
    left: 0,
    width: 25,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
});
const RightSlot = styled('div', {
    marginLeft: 'auto',
    paddingLeft: 20,
    color: '$gray11',
    '[data-highlighted] > &': { color: '$loContrast' },
    '[data-disabled] &': { color: '$gray8' },
});
// Exports
const ContextMenuRoot = styled(ContextMenuPrimitive.Root, {});
const ContextMenuTrigger = ContextMenuPrimitive.Trigger;
const ContextMenuContent = Content;
const ContextMenuItem = StyledItem;
const ContextMenuLabel = StyledLabel;
const ContextMenuSeparator = StyledSeparator;
const ContextMenuSub = ContextMenuPrimitive.Sub;
const ContextMenuSubTrigger = StyledSubTrigger;
const ContextMenuSubContent = SubContent;

export { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuLabel, ContextMenuRoot, ContextMenuSeparator, ContextMenuSub, ContextMenuSubContent, ContextMenuSubTrigger, ContextMenuTrigger, RightSlot };
